import { render, staticRenderFns } from "./TopicDeck.vue?vue&type=template&id=e179d8e8&scoped=true"
import script from "./TopicDeck.vue?vue&type=script&lang=js"
export * from "./TopicDeck.vue?vue&type=script&lang=js"
import style0 from "./TopicDeck.vue?vue&type=style&index=0&id=e179d8e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e179d8e8",
  null
  
)

export default component.exports